import { Component } from "react";

import { type ListEntityType } from "utilities/list/list.types";

import { BTIconFunnelX } from "commonComponents/btWrappers/BTIcon";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { emptyStateIconSize } from "commonComponents/entity/emptyState/common/EmptyState.api.types";
import { EmptyState } from "commonComponents/entity/emptyState/EmptyState";

import { type FilterEntity } from "entity/filters/Filter/Filter.api.types";

export interface IFilteredEmptyState {
    entityTitlePlural: string;
    entityType?: ListEntityType;
    filterEntity?: FilterEntity;
}

export class FilteredEmptyState extends Component<IFilteredEmptyState> {
    render() {
        const { entityTitlePlural } = this.props;

        return (
            <EmptyState
                title="No results"
                className="bds-h-full"
                image={
                    <BTIconFunnelX
                        size={emptyStateIconSize}
                        className="EmptyStateIcon"
                        data-testid="EmptyStateIcon"
                    />
                }
            >
                <BTRow>
                    <span>
                        Adjust or clear your filters to find the {entityTitlePlural} you're looking
                        for.
                    </span>
                </BTRow>
            </EmptyState>
        );
    }
}
